import React from "react"
import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { LinkButton } from "../index"
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as styles from "./RecruitEntry.module.scss"
// import styled from 'styled-components'
import { RecruitThemeContent } from "./index"


const RecruitEntry = () => {

  const breakpoints = useBreakpoint();

  return (
    <div className={styles.RecruitEntry}>
      <div className={styles.RecruitEntry__inner}>
        {
          breakpoints.tb ?
            null
            :
            <StaticImage
              layout="fullWidth"
              src="../../images/recruit/top/recruit_form_bnr.jpg"
              alt="recruit_form_bnr"
              placeholder="tracedSVG"
            />
        }
        <div className={styles.RecruitEntry__content}>
          <div className={styles.RecruitEntry__contentTop}>
            <RecruitThemeContent />
          </div>
          {
            breakpoints.tb ?
              <div>
                <StaticImage
                  layout="fullWidth"
                  src="../../images/recruit/top/recruit_form_bnr-sp.jpg"
                  alt="recruit_form_bnr"
                  placeholder="tracedSVG"
                />
              </div>
              :
              null
          }
          <div className={styles.RecruitEntry__contentBtm}>
            <LinkButton link={`/entry/`} target="">
              エントリー
            </LinkButton>
          </div>
        </div>
      </div>

      <div className={styles.RecruitEntry__contact}>
        <div className={styles.RecruitEntry__contactIcon}>
          <StaticImage
            layout="fullWidth"
            src="../../images/recruit/top/entry_msg_icon@2x.png"
            alt="entry_msg_icon"
            placeholder="tracedSVG"
          />
        </div>
        <div className={styles.RecruitEntry__contactText}>
          <a href="/contact/">メールでのお問い合わせはこちら</a>
          <span>担当：総務部採用担当　小林・藤部</span>
        </div>
      </div>
      <div className={styles.RecruitEntry__contactText}>
        <div className={styles.RecruitEntry__contactmynavi}>
          <a
            href="https://job.mynavi.jp/27/pc/search/corp95579/outline.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://job.mynavi.jp/conts/kigyo/2027/logo/banner_logo_195_60.gif"
              alt="マイナビ2027"
              style={{ border: 0 }}
            />
          </a>
        </div>
      </div>
    </div>
  )
}
export default RecruitEntry

